import { render, staticRenderFns } from "./subeRegistros.vue?vue&type=template&id=3de8661c&"
import script from "./subeRegistros.vue?vue&type=script&lang=js&"
export * from "./subeRegistros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports